import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCA: CultureInfo = {
  name: 'en-CA',
  displayName: 'English (Canada)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CA',
  parent: CultureInfoEn
};
